import { api } from "@/lib/api";

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const permissionState = () => ("Notification" in window ? Notification.permission : "unsupported");

function base64UrlToBytes(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function getSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Este navegador não suporta notificações push.");
  if (isIOS() && !isStandalone()) throw new Error("No iPhone/iPad, primeiro adicione o Clicou, Guardou! à Tela de Início (Compartilhar → Adicionar à Tela de Início) e abra pelo ícone.");
  const reg = await registerSW();
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw Object.assign(new Error("denied"), { code: "denied" });
  const { data } = await api.get("/push/vapid-public-key");
  const existing = await reg.pushManager.getSubscription();
  const sub = existing || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: base64UrlToBytes(data.publicKey) }));
  await api.post("/push/subscribe", { ...sub.toJSON(), user_agent: navigator.userAgent });
  return sub;
}

export async function disablePush() {
  const sub = await getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe();
  }
}

export const LEAD_OPTIONS = [
  { value: 0, label: "No horário exato" },
  { value: 5, label: "5 minutos antes" },
  { value: 15, label: "15 minutos antes" },
  { value: 30, label: "30 minutos antes" },
  { value: 60, label: "1 hora antes" },
  { value: 1440, label: "1 dia antes" },
  { value: "custom", label: "Personalizado" },
];

export const leadLabel = (m) => (m == null ? "Padrão" : LEAD_OPTIONS.find((o) => o.value === m)?.label || (m < 60 ? `${m} min antes` : m < 1440 ? `${Math.round(m / 60)} h antes` : `${Math.round(m / 1440)} dia(s) antes`));
